export const configs = {
    APP_NAME: 'Gyminify',
    BASE_URL: 'https://gyminify.com/api/v1',
    // BASE_URL: 'http://13.200.99.30/api/v1',
    // BASE_URL: 'http://localhost:8085/api/v1',
    PAGE_SIZE: 10,
    FILE_UPLOAD_S3_URL: 'https://gyminify-uploads.s3.ap-south-1.amazonaws.com',
}